import { apiRequest } from './client';
import type { EventSeverity } from '../types';

export interface PersistedEvent {
  id: string;
  deviceId: string | null;
  deviceName: string;
  eventType: string;
  severity: EventSeverity;
  description: string;
  timestamp: string;
  acknowledged: boolean;
  acknowledgedAtUtc: string | null;
  acknowledgedByUserId: string | null;
}

export interface EventPage {
  items: PersistedEvent[];
  total: number;
  page: number;
  pageSize: number;
  unacknowledgedCount: number;
  severityCounts: Partial<Record<EventSeverity, number>>;
}

export interface EventFilters {
  severity?: string;
  type?: string;
  deviceId?: string;
  acknowledged?: boolean;
  from?: string;
  to?: string;
  search?: string;
  page?: number;
  pageSize?: number;
}

export const getEvents = (filters: EventFilters = {}, signal?: AbortSignal) => {
  const params = new URLSearchParams();
  for (const [name, value] of Object.entries(filters)) {
    if (value !== undefined && value !== '') params.set(name, String(value));
  }
  return apiRequest<EventPage>(`/api/events?${params}`, { signal });
};

export const setEventAcknowledgement = (eventId: string, acknowledged: boolean) =>
  apiRequest<PersistedEvent>(`/api/events/${encodeURIComponent(eventId)}/acknowledgement`, {
    method: 'PUT',
    body: { acknowledged },
  });
